'use client'

import { Button } from '../ui/button'
import { motion } from 'framer-motion'
import React, { useRouter } from 'next/navigation'
import toast from 'react-hot-toast'

interface IProps {}

export default function DraftMode({}: IProps) {
  const router = useRouter()
  async function onClickExitPreview() {
    toast.loading('Exiting preview mode...', { id: 'EXIT' })
    await fetch('/api/draft/disable')
    toast.success('Done. Loading Published data...', { id: 'EXIT' })
    router.refresh()
  }

  async function onClickRebuildMenus() {
    toast.loading('Refreshing MainMenu globals...', { id: 'PREVIEW' })
    const response = await fetch(process.env.NEXT_PUBLIC_VERCEL_REBUILD_WEBHOOK_URL!)
    const vercelResp = await response.json()
    if (vercelResp.job.state === 'PENDING') {
      toast.success('Fresh build requested.', { id: 'PREVIEW' })
    } else {
      toast.error('Rebuild request failed.', { id: 'PREVIEW' })
    }
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 1 }}
      style={{ position: 'fixed', zIndex: 99999, bottom: '16px', left: '16px' }}
      className="space-y-4 p-4 bg-black flex flex-col bg-opacity-70 backdrop-blur-md justify-center"
    >
      <h5 className="font-terminal text-white text-sm text-opacity-70">
        DRAFT MODE: <span className="animate-pulse text-telesoft">0N</span>
      </h5>
      <Button
        onClick={onClickRebuildMenus}
        variant="outline"
        className=" text-white border-white hover:border-black"
      >
        Rebuild Menus
      </Button>
      <Button
        onClick={onClickExitPreview}
        variant="outline"
        className="text-white border-white hover:border-black"
      >
        Exit Preview Mode
      </Button>
    </motion.div>
  )
}
